import Ajax from 'js/utils/ajax/ajax';

export const removeUserFromServiceSupplier = (
  serviceSupplierId: number,
  userId: number
): Promise<boolean> =>
  Ajax.delete(`/useradmin/v1/users/${userId}/servicesuppliers/${serviceSupplierId}`);
